// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a54c369e","508":"81613d13","776":"a89445fa"}[chunkId] + ".chunk.js";
};